<template>
  <div>
    <div v-if="hasProgressItems" class="progress-breakdown d-flex">
      <div
        v-for="item in nonEmptyProgressItems"
        :key="item.color"
        :style="progressItemStyle(item)"
        :class="item.color"
        class="progress-breakdown__item hoverable"
      >
        <v-tooltip top color="black">
          <template #activator="{ on, attrs }">
            <div
              class="progress-breakdown__tooltip"
              v-bind="attrs"
              v-on="on"
            ></div>
          </template>
          <span :key="item.color">
            {{ item.tooltipPrefix && item.tooltipPrefix + ' ' }}
            {{ item.count.toLocaleString() }}
          </span>
        </v-tooltip>
      </div>
    </div>
    <div v-else class="progress-breakdown">
      <div
        class="progress-breakdown__item grey lighten-3"
        :class="placeholderProgressItem.class"
        :style="placeholderProgressItem.style"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBreakdown',
  props: {
    progressItems: {
      type: Array,
      required: true,
    },
    height: {
      type: Number,
      default: 16,
    },
  },
  computed: {
    hasProgressItems() {
      return (
        this.progressItems.length > 0 &&
        this.progressItems.some((item) => item.count > 0)
      );
    },
    progressItemTotal() {
      return this.progressItems.reduce(
        (total, p) => p.count + total,
        0
      );
    },
    nonEmptyProgressItems() {
      return this.progressItems.filter((item) => item.count > 0);
    },
    placeholderProgressItem() {
      return {
        style: {
          width: '100%',
          height: `${this.height}px`,
        },
        class: 'grey lighten-2',
      };
    },
  },
  methods: {
    progressItemPercentage(item) {
      return (item.count / this.progressItemTotal) * 100;
    },
    progressItemStyle(item) {
      return {
        width: `${this.progressItemPercentage(item)}%`,
        height: `${this.height}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-breakdown .progress-breakdown__item.hoverable:hover {
  filter: brightness(0.9);
}

.progress-breakdown {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
}

.progress-breakdown__tooltip {
  width: 100%;
  height: 100%;
}
</style>
